<div class="cardLayout">
    <div class="d-flex flex-row align-items-center justify-content-between" style="flex-wrap: wrap; gap: 8px">
        <h4>Best Match: Likely Caller Details</h4>
        <div class="d-flex flex-row">
            <button
                class="thumb-btn"
                [class.thumb-active]="feedback() === 'bad'"
                (click)="setFeedback('bad')"
                title="Bad match"
            >
                <mat-icon [svgIcon]="'icon-thumbs-down'" class="bmc-thumb-icon"></mat-icon>
            </button>
            <button
                class="thumb-btn"
                [class.thumb-active]="feedback() === 'good'"
                (click)="setFeedback('good')"
                title="Good match"
            >
                <mat-icon [svgIcon]="'icon-thumbs-up'" class="bmc-thumb-icon"></mat-icon>
            </button>
        </div>
    </div>

    @if (bmcSections().length === 0) {
    <p class="caption">No caller data available.</p>
    }

    <div class="d-flex flex-column psic-gap-5">
        @for (section of bmcSections(); track section.title) { @if (isCompact()) {
        <div class="d-flex flex-column psic-gap-6">
            <div class="d-flex flex-row psic-gap-4 align-items-center">
                <mat-icon [svgIcon]="section.roleImage" class="card-description mat-icon-64"></mat-icon>
                <h6>{{ section.baseTitle }}</h6>
            </div>
            <div class="d-flex flex-column psic-gap-2">
                <div class="caption-bold">{{ section.title }}</div>
                @for (detail of section.details; track detail.label) {
                <div class="d-flex flex-row justify-content-between">
                    <div class="caption-bold">{{ detail.label }}</div>
                    <div class="caption text-end d-flex align-items-center" style="gap: 4px">
                        @if (detail.key === 'policyNumber') {
                        <a class="bmc-link" (click)="navigateToPolicy(detail.value)">{{ detail.value }}</a>
                        <mat-icon
                            class="bmc-icon-sm"
                            [svgIcon]="'copy'"
                            (click)="copyToClipboard(detail.value)"
                            title="Copy"
                        ></mat-icon>
                        } @else if (detail.key === 'producerCode') {
                        <span class="bmc-producer-code">{{ detail.value }}</span>
                        <mat-icon
                            class="bmc-icon-sm"
                            [svgIcon]="'external-link'"
                            (click)="navigateToAMS(detail.value)"
                            title="Open in AMS"
                        ></mat-icon>
                        } @else {
                        {{ detail.value }}
                        }
                    </div>
                </div>
                }
            </div>
        </div>
        } @else {
        <div class="d-flex flex-row justify-content-between">
            <div class="d-flex flex-column psic-gap-4">
                <mat-icon [svgIcon]="section.roleImage" class="card-description mat-icon-64"></mat-icon>
                <h6>{{ section.baseTitle }}</h6>
            </div>
            <div class="d-flex flex-column psic-gap-2 right-content">
                <div class="caption-bold">{{ section.title }}</div>
                @for (detail of section.details; track detail.label) {
                <div class="d-flex flex-row justify-content-between">
                    <div class="caption-bold">{{ detail.label }}</div>
                    <div class="caption text-end d-flex align-items-center" style="gap: 4px">
                        @if (detail.key === 'policyNumber') {
                        <a class="bmc-link" (click)="navigateToPolicy(detail.value)">{{ detail.value }}</a>
                        <mat-icon
                            class="bmc-icon-sm"
                            [svgIcon]="'copy'"
                            (click)="copyToClipboard(detail.value)"
                            title="Copy"
                        ></mat-icon>
                        } @else if (detail.key === 'producerCode') {
                        <span class="bmc-producer-code">{{ detail.value }}</span>
                        <mat-icon
                            class="bmc-icon-sm"
                            [svgIcon]="'external-link'"
                            (click)="navigateToAMS(detail.value)"
                            title="Open in AMS"
                        ></mat-icon>
                        } @else {
                        {{ detail.value }}
                        }
                    </div>
                </div>
                }
            </div>
        </div>
        } @if (!$last) {
        <div class="separator"></div>
        } }
    </div>
</div>
